import type { Id, Match, Slot } from './types.js';

/**
 * Wer steht auf einer Seite? Normal genau ein Team; bei wechselnden Partnern
 * (Americano, `GroupsConfig.partners`) zwei Einzelspieler, die für dieses eine
 * Spiel ein Doppel bilden. Alles, was „ist das Team in diesem Spiel?" fragt
 * (Warteschlange, Tabelle, Rückzug), geht über diese beiden Funktionen.
 */
export function slotTeamIds(s: Slot): Id[] {
  if (s.kind !== 'team') return [];
  return s.partnerId ? [s.teamId, s.partnerId] : [s.teamId];
}

/** Seite, auf der das Team spielt — auch als Partner */
export function sideOf(m: Match, teamId: Id): 'A' | 'B' | null {
  if (slotTeamIds(m.a).includes(teamId)) return 'A';
  if (slotTeamIds(m.b).includes(teamId)) return 'B';
  return null;
}
